import React from 'react'

const ContentWrapper = ({ wrapperClassContainer, children }) => {
    return (
        <div className={wrapperClassContainer}>
            {children}
        </div>
    )
}

export default ContentWrapper;
